export let NewsroomTheme;
(function (_NewsroomTheme) {
  let Status = /*#__PURE__*/function (Status) {
    Status["BETA"] = "beta";
    Status["STABLE"] = "stable";
    return Status;
  }({});
  _NewsroomTheme.Status = Status;
  let Feature = /*#__PURE__*/function (Feature) {
    Feature["CATEGORIES"] = "categories";
    Feature["SEARCH"] = "search";
    Feature["MEDIA_GALLERIES"] = "media_galleries";
    Feature["BOILERPLATE"] = "boilerplate";
    Feature["MULTI_LANGUAGE"] = "multi_language";
    Feature["CUSTOM_COLORS"] = "custom_colors";
    Feature["OPTIONAL_PRIVACY_PORTAL"] = "optional_privacy_portal";
    Feature["CUSTOM_CSS_JAVASCRIPT"] = "custom_css_javascript";
    Feature["HOMEPAGE_CONTACTS"] = "homepage_contacts";
    Feature["SUBSCRIBE_FORM"] = "subscribe_form";
    Feature["STORY_PINNING"] = "story_pinning";
    Feature["TITLE_FORMATTING"] = "title_formatting";
    Feature["CTA_BUTTONS"] = "cta_buttons";
    Feature["VIDEO_LAYOUT"] = "video_layout";
    Feature["EMBED_LAYOUT"] = "embed_layout";
    Feature["STRICT_TRACKING_POLICY"] = "strict_tracking_policy";
    return Feature;
  }({}); // DEV-19123
  _NewsroomTheme.Feature = Feature;
  function isFeatureSupported(theme, feature) {
    return theme.features.includes(feature);
  }
  _NewsroomTheme.isFeatureSupported = isFeatureSupported;
})(NewsroomTheme || (NewsroomTheme = {}));
export let NewsroomThemePreset;